import React from "react";
import EventDetailsLeftArea from "./EventDetailsLeftArea";
import EventRightArea from "./EventRightArea";

const EventDetailsWrapper = ({ evt }) => (
  <div className="hn-detail-wrap">
    <div className="hn-detail-main">
      <EventDetailsLeftArea evt={evt} />
      <EventRightArea evt={evt} />
    </div>
  </div>
);

export default EventDetailsWrapper;
